//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ABCD2",
  data() {
    return {
      defaultJson: {
        "Age ≥ 60 years": "年龄 ≥ 60 岁",
        "moderate risk": "中危",
        "just occurred": "小于 10 分钟",
        "high risk": "高危",
        "Clinical Features": "临床表现",
        Diabetes: "糖尿病",
        "Speech disturbance, no weakness": "言语障碍，不伴肌无力",
        Hypertension: "高血压",
        "low risk": "低危",
        "10 - 59 minutes (short)": "10 - 59 分钟",
        ">= 60 minutes (short)": "≥ 60 分钟",
        "10 - 59 minutes": "10 - 59 分钟",
        ">= 60 minutes": "60 分钟或更久",
        "Unilateral weakness": "单侧肌无力",
        "just occurred (short)": "< 10 分钟",
        "No weakness": "无肌无力",
        "Unilateral weakness (short)": "单侧",
        "Speech disturbance, no weakness (short)": "仅言语障碍",
        "Symptom Duration": "症状持续时间",
        "No weakness (short)": "无肌无力",
      },
      form: {
        diabetes: "0",
        hypertension: "0",
        ageOver60: "0",
        clinic: "",
        duration: "",
      },
      dataList1: [
        { value: "0", name: "无肌无力", shortName: "无肌无力" },
        { value: "1", name: "言语障碍，不伴肌无力", shortName: "仅言语障碍" },
        { value: "2", name: "单侧肌无力", shortName: "单侧" },
      ],
      dataList2: [
        { value: "0", name: "小于 10 分钟", shortName: "< 10 分钟" },
        { value: "1", name: "10 - 59 分钟", shortName: "10 - 59 分钟" },
        { value: "2", name: "60 分钟或更久", shortName: "≥ 60 分钟" },
      ],
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration
        let result =
          form.diabetes +
          form.hypertension +
          form.ageOver60 +
          form.clinic +
          form.duration;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/ABCD2.vue